import { CardHeader, CardBody, Button, Card, Table, InputGroup, InputGroupText, Input, Col } from "reactstrap";
import { FieldArray } from "formik";
import { TablesWithoutBorders } from "../../../pages/Tables/BasicTables/BasicTablesCode";
import InputField from "../../Utils/InputField";
import SelectField from "../../Utils/SelectField";
import { AttributeTypeOptions } from "./constants/initialvalues";
import useFieldAttributes from "./constants/fieldattribute";
import { Link } from "react-router-dom";
import { useEffect } from "react";

export default function Attribute({ values, touched, errors, setFieldTouched, setFieldValue, initialValues, handleChange, setTouched, usageoptions, provisionOptions, selectedAttributeName, formInitialValues, isEdit }) {
    const { isEmptyOrInvalidField, handleSelectedAttributeName, handleAttributeChangeUpdate, } = useFieldAttributes();
    const initializeDefaultRow = () => {
        const defaultRow = { type: '', name: '', value: '' };
        setFieldValue('attributeList', [defaultRow]);

        setTouched({
            ...touched,
            attributeList: {
                0: {
                    type: false,
                    name: false,
                    value: false,
                },
            },
        });
    };

    const handleAddAttribute = (push) => {
        const lastIndex = values.attributeList?.length - 1;
        if (lastIndex === -1 || !isEmptyOrInvalidField(lastIndex, values)) {
            push({ type: '', name: '', value: '' });
            setTouched({
                ...touched,
                attributeList: {
                    ...touched.attributeList,
                    [values.attributeList?.length]: {
                        type: false,
                        name: false,
                        value: false,
                    },
                },
            });
        }
    };

    const handleClearCurrentRow = (index) => {
        setFieldValue(`attributeList[${index}].type`, '');
        setFieldValue(`attributeList[${index}].name`, '');
        setFieldValue(`attributeList[${index}].value`, '');

        setTouched({
            ...touched,
            attributeList: {
                ...touched.attributeList,
                [index]: {
                    type: false,
                    name: false,
                    value: false,
                },
            },
        });
    };

    const isFieldFilled = (field) => {
        return field.type && field.type.value && field.name && field.name.value && (field.value || field.type.value === "Usage Attributes");
    };

    const shouldShowValidation = (index) => {
        if (isEdit && index === 0 && (!formInitialValues.attributeList || formInitialValues.attributeList.length === 0)) {
            return false; 
        }
        return true;
    };

    useEffect(() => {
        if (!values.attributeList || values.attributeList.length === 0) {
            initializeDefaultRow();
        }
    }, [values.attributeList, isEdit, formInitialValues]);

    const attributeList = values.attributeList || [{ type: '', name: '', value: '' }];

    return (
        <>
            <FieldArray name="attributeList">
                {({ push, remove }) => (
                    <Col lg={12}>
                        <div>
                            <div className="align-items-center d-flex">
                                <h4 className="card-title mb-0 flex-grow-1">Attributes</h4>
                            </div>
                            <CardBody>
                                <div className="live-preview">
                                    <div className="table-responsive" style={{ overflow: 'visible' }}>
                                        <div >
                                            <Table className="table-borderless align-middle table-nowrap mb-4">
                                                <thead>
                                                    <tr>
                                                        <th scope="col" style={{ width: '20%' }}>Type</th>
                                                        <th scope="col" style={{ width: '25%' }}>Service Name</th>
                                                        <th scope="col" style={{ width: '25%' }}>Value</th>
                                                        <th scope="col" style={{ width: '30%' }}></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {attributeList.map((val, index) => {
                                                        const isUsageAttribute = attributeList[index].type?.value === "Usage Attributes";
                                                        const isProvisionalAttribute = attributeList[index].type?.value === "Provisional Attributes";
                                                        const isCurrentRowFilled = isFieldFilled(attributeList[index]);
                                                        const showValidation = shouldShowValidation(index);

                                                        return (
                                                            <tr key={index}>
                                                                <td style={{ width: '20%' }}>
                                                                    <SelectField
                                                                        className=""
                                                                        placeholder={''}
                                                                        name={`attributeList[${index}].type`}
                                                                        value={initialValues.attributeList?.[index]?.type ?
                                                                            AttributeTypeOptions?.filter((type) =>
                                                                                type.label === initialValues.attributeList[index]?.type
                                                                            )[0]
                                                                            : attributeList[index].type
                                                                        }
                                                                        handleChange={(val) => {
                                                                            setFieldValue(`attributeList[${index}].type`, val);
                                                                            setFieldTouched(`attributeList[${index}].type`, showValidation);
                                                                            if (val.value === "Usage Attributes") {
                                                                                setFieldValue(`attributeList[${index}].value`, '');
                                                                            }
                                                                        }}
                                                                        options={AttributeTypeOptions}
                                                                        showError={showValidation}
                                                                    />
                                                                </td>
                                                                <td style={{ width: '25%' }}>
                                                                    <SelectField
                                                                        className=""
                                                                        name={`attributeList[${index}].name`}
                                                                        value={initialValues.attributeList?.[index]?.name ?
                                                                            (isProvisionalAttribute ? provisionOptions : usageoptions)?.filter((name) =>
                                                                                name.label === initialValues.attributeList[index]?.name
                                                                            )[0]
                                                                            : attributeList[index].name
                                                                        }
                                                                        handleChange={(val) => {
                                                                            handleSelectedAttributeName(val);
                                                                            setFieldValue(`attributeList[${index}].name`, val);
                                                                            setFieldTouched(`attributeList[${index}].name`, showValidation);
                                                                        }}
                                                                        options={isProvisionalAttribute ? provisionOptions : isUsageAttribute ? usageoptions : []}
                                                                        disabled={!isProvisionalAttribute && !isUsageAttribute}
                                                                        placeholder={!isProvisionalAttribute && !isUsageAttribute ? "" : ""}
                                                                        showError={showValidation}
                                                                    />
                                                                </td>
                                                                <td style={{ width: '25%' }}>
                                                                    <InputGroup key={index}>
                                                                        <InputField
                                                                            name={`attributeList[${index}].value`}
                                                                            className=""
                                                                            placeholder={isUsageAttribute ? "Not applicable" : ""}
                                                                            type="text"
                                                                            disabled={isUsageAttribute}
                                                                            handleChange={e => {
                                                                                if (!isUsageAttribute) {
                                                                                    handleChange(e);
                                                                                    handleAttributeChangeUpdate(index, e);
                                                                                }
                                                                            }}
                                                                            value={isUsageAttribute ? '' : attributeList[index].value}
                                                                            showError={showValidation}
                                                                        />
                                                                    </InputGroup>
                                                                </td>
                                                                <td style={{ width: '30%' }}>
                                                                    <div className="d-flex align-items-center gap-2">
                                                                        {isCurrentRowFilled && (
                                                                            <>
                                                                                <div>
                                                                                    <i
                                                                                        className="mdi mdi-plus-circle-outline fs-5 text-primary me-1"
                                                                                        role="button"
                                                                                        onClick={() => handleAddAttribute(push)}
                                                                                    ></i>
                                                                                </div>


                                                                                <i className="ri-close-line fw-bold align-middle fs-4 cross-icon-color"
                                                                                    role="button"
                                                                                    onClick={() => handleClearCurrentRow(index)}
                                                                                ></i>

                                                                            </>
                                                                        )}

                                                                        {index > 0 && !isCurrentRowFilled && (
                                                                            <Link
                                                                                to="#"
                                                                                className="link-danger fs-5"
                                                                                onClick={() => {
                                                                                    remove(index);
                                                                                    if (attributeList.length === 1) {
                                                                                        initializeDefaultRow();
                                                                                    }
                                                                                }}
                                                                            >
                                                                                <i
                                                                                    data-testid="delete"
                                                                                    className="ri-delete-bin-5-line"
                                                                                ></i>
                                                                            </Link>
                                                                        )}
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        )
                                                    })}
                                                </tbody>
                                            </Table>
                                        </div>
                                    </div>
                                </div>
                                <div className="d-none code-view">
                                    <pre className="language-markup default-height">
                                        <code>
                                            <TablesWithoutBorders />
                                        </code>
                                    </pre>
                                </div>
                            </CardBody>
                        </div>
                    </Col>
                )}
            </FieldArray>
        </>
    )
}